import { links } from 'bzx-common/src/config/appConfig'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import DashboardVM from 'src/components/Dashboard/DashboardVM'
import { observer } from 'mobx-react'
import OokiversityPosts from './OokiversityPosts'
import banner from './ookiversity-banner.jpeg'

export const Learn = ({ vm }: { vm: DashboardVM }) => (
  <>
    <div className="learn-grid">
      <div className="panel--simple pos-rel overflow-hidden">
        <img className="learn__banner" src={banner} />
      </div>
      <div className="flex-col">
        <div className="panel--simple md-padded-2 height-100p margin-bottom-1">
          <h3 className="txt-slogan">{'Learn crypto & DeFi fundamentals!'}</h3>
          <ul className="list-spaced-2 margin-bottom-0">
            <li>Tutorials</li>
            <li>Articles</li>
            <li>Videos</li>
            <li>Lessons</li>
          </ul>
        </div>
        <div className="panel--simple md-padded-2 margin-bottom-1 txt-explanation">
          Ookiversity educates its students on the core mission of cryptocurrency and blockchain
          technology.
        </div>
        <ExternalLink
          className="btn btn--blue btn--small-corners flex-center"
          href={links.ookiversity}>
          Go to Blog
        </ExternalLink>
      </div>
    </div>
    <OokiversityPosts blogStore={vm.rootStore.blogStore} />
  </>
)

export default observer(Learn)
